document.addEventListener('DOMContentLoaded', () => {

  const trigger = document.querySelector('.round-look-trigger');
  const drawer = document.getElementById('round-look-drawer');
  const overlay = document.getElementById('round-look-overlay');
  const close = document.getElementById('round-look-close');
  const addButton = document.getElementById('round-look-add');

  if (!trigger || !drawer || !overlay || !close || !addButton) return;


  /*
   * DESKTOP:
   * Sacamos drawer y overlay de la estructura del producto
   * para evitar problemas de z-index con carruseles.
   *
   * MÓVIL:
   * Los dejamos en su posición original porque el sistema
   * de drawer móvil ya funcionaba correctamente.
   */

  if (window.innerWidth >= 990) {
    document.body.appendChild(overlay);
    document.body.appendChild(drawer);
  }


  /*
   * FORZAR ESTADO INICIAL CERRADO
   */

  drawer.classList.remove('open');
  overlay.style.display = 'none';

  document.body.style.overflow = '';
  document.documentElement.style.overflow = '';


  /*
   * BOTÓN AÑADIR
   */

  function updateAddButton() {

    const products =
      drawer.querySelectorAll('.round-look-product');

    const allSelected =
      [...products].every(
        product => product.dataset.selectedVariantId
      );

    addButton.disabled = !allSelected;

    addButton.classList.toggle(
      'enabled',
      allSelected
    );
  }


  addButton.disabled = true;
  updateAddButton();


  /*
   * ABRIR DRAWER
   */

  let roundLookScrollLocked = false;

function preventBackgroundScroll(event) {

  // Si el toque está dentro del drawer,
  // permitimos el scroll del drawer.
  if (drawer.contains(event.target)) {
    return;
  }

  event.preventDefault();
}


function openDrawer() {

  drawer.classList.add('open');
  overlay.style.display = 'block';

  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';

  // Bloquear el gesto de scroll en la página trasera
  if (!roundLookScrollLocked) {

    document.addEventListener(
  'touchmove',
  preventBackgroundScroll,
  {
    passive: false,
    capture: true
  }
);

    roundLookScrollLocked = true;
  }
}


function closeDrawer() {

  drawer.classList.remove('open');
  overlay.style.display = 'none';

  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';

  // Quitar el bloqueo del scroll
  if (roundLookScrollLocked) {

    document.removeEventListener(
  'touchmove',
  preventBackgroundScroll,
  true
);

    roundLookScrollLocked = false;
  }
}


  /*
   * EVENTOS ABRIR / CERRAR
   */

  trigger.addEventListener('click', openDrawer);

  close.addEventListener('click', closeDrawer);

  overlay.addEventListener('click', closeDrawer);


  /*
   * SELECCIÓN DE TALLAS
   */

  drawer
    .querySelectorAll('.round-look-product')
    .forEach(product => {

      const buttons =
        product.querySelectorAll('.round-look-size');

      buttons.forEach(button => {

        button.addEventListener('click', () => {

          buttons.forEach(btn => {
            btn.classList.remove('active');
          });

          button.classList.add('active');

          product.dataset.selectedVariantId =
            button.dataset.variantId;

          updateAddButton();
        });

      });

    });


  /*
   * AÑADIR LOOK AL CARRITO
   */

  addButton.addEventListener('click', async () => {

    const products =
      drawer.querySelectorAll('.round-look-product');

    const items = [];

    let missingSize = false;


    products.forEach(product => {

      const variantId =
        product.dataset.selectedVariantId;

      if (!variantId) {
        missingSize = true;
        return;
      }

      items.push({
        id: Number(variantId),
        quantity: 1
      });

    });


    if (missingSize) {

      alert(
        'Selecciona una talla para cada producto.'
      );

      return;
    }


    try {

      const response = await fetch('/cart/add.js', {

        method: 'POST',

        headers: {
          'Content-Type': 'application/json'
        },

        body: JSON.stringify({
          items: items
        })

      });


      if (!response.ok) {
        throw new Error('Error');
      }


      closeDrawer();


    } catch (error) {

      alert(
        'Ha ocurrido un error al añadir el look al carrito.'
      );

    }

  });

});